export default "/fonts/vendor/primeicons/primeicons.eot?dfbfef2de4bfb34e9722e83542173aaf";